export const randomNumber = ({ maxRange }: { maxRange: number }) => {
    return Math.floor(Math.random() * maxRange) + 1;
};
